import * as React from "react";
import { ToastContainer as ToastContainer$2, Slide, toast } from "react-toastify";
import { Icon } from "@grandvisionhq/icons";
import { useIntl } from "@grandvisionhq/state";
import toastService from "./ToastService.js";
/* empty css           */
const defaultPositionOption = toast.POSITION.BOTTOM_CENTER;
const ToastContainer = () => {
  const { getLabel } = useIntl();
  React.useEffect(() => toastService.init(getLabel), [getLabel]);
  return /* @__PURE__ */ React.createElement(
    ToastContainer$2,
    {
      autoClose: 6e3,
      closeButton: /* @__PURE__ */ React.createElement(Icon, { name: "close" }),
      position: defaultPositionOption,
      transition: Slide,
      newestOnTop: true
    }
  );
};
const ToastContainer$1 = React.memo(ToastContainer);
export {
  ToastContainer,
  ToastContainer$1 as default
};
//# sourceMappingURL=ToastContainer.js.map
